// extracted by mini-css-extract-plugin
export default {"fadeIn":"style-module--fadeIn--0rUEG","fadeOut":"style-module--fadeOut--Bc4qq","select":"style-module--select--AvvDh"};